module.exports = __webpack_public_path__ + "img/17860_S.cb790e1e.png";